import React from 'react'

import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'

import { version } from '../../../package.json'

import { App } from './App'
import './global.css'
import i18n from './i18n'

const release = `<!-- v${version} -->`

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <div dangerouslySetInnerHTML={{ __html: release }} />
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
)
